<template>
<div>
  <div class="message">
      <div v-if="list.length > 0" class="list">
          <div v-for="(v,k) in list" v-bind:key="k" :class="[v.status==0?'cur':'']" class="item">
              <div class="item__hd">系统消息</div>
              <div class="item__bd">
                  <p class="time">{{v.created_at}}</p>
                  <p class="tit">{{v.msg}}</p>
              </div>
          </div>
      </div>
      <div v-else class="nodata">暂无数据</div>

      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
  <div class="weui-loadmore" v-if="load">
      <i class="weui-loading"></i>
      <span class="weui-loadmore__tips">正在加载</span>
  </div>
  <footbottom></footbottom>
</div>
</template>

<script>
import infiniteScroll from '@/basic/infiniteScroll'
import footbottom from '@/footer'
export default{
  components:{
    footbottom
  },
  directives: {infiniteScroll},
  data(){
    return{
      list:[],
      busy:true,
      load:true,
      page:1
    }
  },
  mounted(){
    this.getAccountMsg();
  },
  methods:{
    getAccountMsg(flag){
      let vm = this;
      vm.ajax("account/msg", "get", 'page='+vm.page, e => {
        vm.load = false;
        if(e.data.list){
          if(flag){
            vm.list =  vm.list.concat(e.data.list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            vm.list =  e.data.list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getAccountMsg(true);
      }, 1000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/message.vue